import { getConfig } from '@cian/config/browser';
import { UnknownError } from '@cian/peperrors/shared';
import { createELKErrorLog, createELKMessageLog, } from '@cian/system-logger/shared';
export class Logger {
    transport;
    errorFilter;
    constructor(params) {
        this.transport = params.transport;
        this.errorFilter = params.errorFilter;
    }
    debug(message, meta) {
        if (process.env.NODE_ENV === 'development' || getConfig().get('logger.browser.debug')) {
            this.transport.write(createELKMessageLog({ message, level: 'debug', meta: meta }));
        }
    }
    info(message, meta) {
        this.transport.write(createELKMessageLog({ message, level: 'info', meta: meta }));
    }
    warning(message, meta) {
        if (typeof message === 'string') {
            this.transport.write(createELKMessageLog({ message, level: 'warning', meta: meta }));
        }
        else {
            if (!this.errorFilter.approve(message)) {
                return;
            }
            this.transport.write(createELKErrorLog({ message, level: 'warning', meta: meta }));
        }
    }
    error(message, meta) {
        if (!this.errorFilter.approve(message)) {
            return;
        }
        const error = typeof message === 'string'
            ? new UnknownError({
                message,
                domain: 'logger.error',
            })
            : message;
        const log = createELKErrorLog({ message: error, level: 'error', meta: meta });
        this.transport.write(log);
    }
}
//# sourceMappingURL=Logger.js.map